import { useMemo } from 'react';
import 'react-range-slider-input/dist/style.css';
import Select from 'react-select';
import { GeneralSettingsCardI } from '..';
import info from '../../../../../../assets/images/icons/info.svg';
import { CustomStyle } from '../../../../../../components/CustomSelectStyle';
import FilterRadioButton from '../../../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../../../components/FilterRadioButtonsContainer';
import Textarea from '../../../../../../components/Textarea';
import { Container, Group } from '../../../styles';

export default function GeneralSettingsCard({
  partner,
  setPartner,
  partnerOptions,
  secondPartner,
  setSecondPartner,
  secondPartnerOptions,
  directResult,
  setDirectResult,
  maxContestsAllowed,
  setMaxContestsAllowed,
  defaultWorkplaceUsesIntegrationWs,
  setDefaultWorkplaceUsesIntegrationWs,
  changesWpDataByWs,
  setChangesWpDataByWs,
  isPartner,
  setIsPartner,
  usesLogoAtEmail,
  setUsesLogoAtEmail,
  particularities,
  setParticularities,
}: GeneralSettingsCardI) {
  const selectedPartner = useMemo(() => partnerOptions.find((opt) => opt.value === partner.value), [partnerOptions, partner]);

  return (
    <Container>
      <div className="card-title">
        Outras configurações
      </div>

      <Group>
        <div className="title">
          <div>
            Parceiro
            {' '}
            <img src={info} alt="info" title="Caso a empresa seja de algum parceiro, selecione-o abaixo." />
          </div>
        </div>
        <Select
          value={partner}
          options={partnerOptions}
          onChange={(partnerOpt) => {
            if (partner.value !== partnerOpt?.value) {
              setIsPartner(false);
              setPartner(partnerOpt!);
              if (!partnerOpt?.value || partnerOpt.value === secondPartner.value) {
                setSecondPartner({ value: null, label: 'Nenhum parceiro' });
              }
            }
          }}
          placeholder="Nenhum parceiro"
          styles={CustomStyle}
          classNamePrefix="react-select"
          className="react-select-container"
        />
      </Group>

      {partner.value && (
        <Group>
          <div className="title">
            <div>
            Empresa é o próprio parceiro?
              {' '}
              <img src={info} alt="info" title="Um parceiro pode ter uma empresa associada para navegação pelo site. Portanto se esta empresa for a empresa do parceiro selecionado acima, marque a opção como sim. Desta forma, quando um usuário desta empresa logar, ele conseguirá navegar entre todas as empresas Matriz e Filial associadas ao parceiro." />
            </div>
          </div>
          <FilterRadioButtonsContainer>
            <FilterRadioButton selected={!isPartner} onClick={() => setIsPartner(false)}>
            Não
            </FilterRadioButton>
            <FilterRadioButton selected={isPartner} onClick={() => setIsPartner(true)} disabled={!!(selectedPartner?.codEmpresaParceiro)}>
            Sim
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
        </Group>
      )}

      <Group>
        <div className="title">
          <div>
            Parceiro segundo pagador
            {' '}
            <img
              src={info}
              alt="info"
              title="Caso a empresa possua um segundo parceiro pagador nas condições comerciais, selecione-o abaixo. Esta opção só fica disponível quando houver um parceiro principal selecionado."
            />
          </div>
        </div>
        <Select
          value={!partner.value ? null : (secondPartner.value ? secondPartner : { value: null, label: 'Nenhum parceiro' })}
          options={secondPartnerOptions}
          onChange={(secondPartnerOpt) => {
            setSecondPartner(secondPartnerOpt ?? { value: null, label: 'Nenhum parceiro' });
          }}
          isDisabled={!partner.value}
          placeholder={!partner.value ? 'Selecione primeiro o parceiro principal' : 'Nenhum parceiro'}
          styles={CustomStyle}
          classNamePrefix="react-select"
          className="react-select-container"
        />
      </Group>

      <Group>
        <div className="title">
          <div>
            Utilizará resultados DIRECT?
            {' '}
            <img src={info} alt="info" title="Quando uma roteirização é realizada através de algum canal que a mesma não tenha sido feita diretamente pelo colaborador, automaticamente enviará um link da roteirização para o e-mail do mesmo." />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={directResult} onClick={() => setDirectResult(true)}>
            Sim
          </FilterRadioButton>
          <FilterRadioButton selected={!directResult} onClick={() => setDirectResult(false)}>
            Não
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>

      <Group>
        <div className="title">
          Máximo de contestações permitidas por consulta
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={maxContestsAllowed === 1} onClick={() => setMaxContestsAllowed(1)}>
                    1
          </FilterRadioButton>
          <FilterRadioButton selected={maxContestsAllowed === 2} onClick={() => setMaxContestsAllowed(2)}>
                    2
          </FilterRadioButton>
          <FilterRadioButton selected={maxContestsAllowed === 3} onClick={() => setMaxContestsAllowed(3)}>
                    3
          </FilterRadioButton>
          <FilterRadioButton selected={maxContestsAllowed === 4} onClick={() => setMaxContestsAllowed(4)}>
                    4
          </FilterRadioButton>
          <FilterRadioButton selected={maxContestsAllowed === 5} onClick={() => setMaxContestsAllowed(5)}>
                    5
          </FilterRadioButton>
          <FilterRadioButton selected={maxContestsAllowed === 6} onClick={() => setMaxContestsAllowed(6)}>
                    6
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>

      <Group>
        <div className="title">
          Novos Locais de Trabalho criados via WS realizam integrações por padrão?
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={defaultWorkplaceUsesIntegrationWs} onClick={() => setDefaultWorkplaceUsesIntegrationWs(true)}>
                    Realizam integrações
          </FilterRadioButton>
          <FilterRadioButton selected={!defaultWorkplaceUsesIntegrationWs} onClick={() => setDefaultWorkplaceUsesIntegrationWs(false)}>
                    Não realizam
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>

      <Group>
        <div className="title">
          Dados do local de trabalho podem ser alterados via WS?
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={!changesWpDataByWs} onClick={() => setChangesWpDataByWs(false)}>
                    Não
          </FilterRadioButton>
          <FilterRadioButton selected={changesWpDataByWs} onClick={() => setChangesWpDataByWs(true)}>
                    Sim
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
        {changesWpDataByWs && (
          <strong>Nesta opção, fica sob responsabilidade do cliente a atualização das informações de endereços. Vale reforçar que qualquer alteração realizada, irá alterar a descrição dos locais das consultas realizadas no passado.</strong>
        )}
      </Group>

      <Group>
        <div className="title">
          Inserir logomarca nos e-mails?
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={usesLogoAtEmail} onClick={() => setUsesLogoAtEmail(true)}>
                    Sim
          </FilterRadioButton>
          <FilterRadioButton selected={!usesLogoAtEmail} onClick={() => setUsesLogoAtEmail(false)}>
                    Não
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>

      <Group>
        <div className="title">
          Particularidades
        </div>
        <Textarea
          value={particularities}
          onChange={(e) => setParticularities(e.target.value)}
          maxLength={1000}
          placeholder='Máx. 1000 caract.'
        />
      </Group>

    </Container>
  );
}
